export enum LocalStorageVariables {
  ApiBaseUrl = 'apiBaseUrl',
  LastPageActivityTimeStamp = 'LastPageActivityTimeStamp',
  LastUserActivityTimeStamp = 'LastUserActivityTimeStamp',
  Token = 'token',
  RefreshToken = 'refreshToken',
  ExpiresAt = 'expiresAt',
  UserInactivityPeriod = 'userInactivityPeriod',
  TenantConfiguration = 'tenantConfiguration',
  Definitions = 'definitions',
  RawDefinitions = 'raw-definitions',
  DynamicFilterOptions = 'dynamic-filter-options',
  UserName = 'userName',
  IsRequiredPasswordChange = 'isRequiredPasswordChange',
  ClaimSetVisitsStorage = 'ClaimSetVisitsStorage',
  FilterUserOptions = 'FilterUserOptions',
  OpenDrawerQueue = 'OpenDrawerQueue',
}
